import React, { Component } from 'react';
import { Radio, Modal, Typography } from 'antd';
import setNotification from '../../../utils/setNotification.utils';

class DischargeModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 1,
      activeValue: 2,
      loading: false
    };
  }

  setActiveIndex = (index, value) => {
    this.setState({ activeIndex: index, activeValue: value });
  };

  handleDischarge = async () => {
    const { dischargeAction, doDischarge, onHide } = this.props;
    const { activeValue } = this.state;

    try {
      this.setState({ loading: false });
      await dischargeAction(activeValue, !doDischarge ? true : false);
    } catch (error) {
      setNotification(
        'error',
        'Error!',
        'An error occurred while discharging the patient.'
      );
    } finally {
      this.setState({ loading: false });
      onHide();
    }
  };

  render() {
    const { onHide, doDischarge, hasPendingBill } = this.props;
    const { activeIndex, loading } = this.state;

    return (
      <Modal
        title={!doDischarge ? 'Discharge Patient?' : 'Readmit Patient?'}
        visible={true}
        confirmLoading={loading}
        okText={!doDischarge ? 'Discharge' : 'Readmit'}
        okButtonProps={{
          size: 'large',
          type: 'primary',
          className: 'ptw-btn btn-primary'
        }}
        onOk={this.handleDischarge}
        cancelText="Cancel"
        cancelButtonProps={{
          size: 'large',
          type: 'default',
          className: 'ptw-btn'
        }}
        onCancel={onHide}
      >
        {!doDischarge ? (
          <React.Fragment>
            <Typography.Paragraph>
              Discharged patients can have their access to their app limited.
            </Typography.Paragraph>

            <Typography.Paragraph>
              You can choose to have a discharged patient's exercise program
              prescription expire after a certain amount of time. After a
              prescription has expired, the patient will be told that they need
              to book a new appointment to access an exercise program
              prescription.
            </Typography.Paragraph>
            <Typography.Paragraph>
              Select how long you want your patient to have access to their app
              after they are discharged.
            </Typography.Paragraph>
            <Radio.Group
              onChange={this.handleSizeChange}
              className="ptw-btn"
              size="large"
            >
              <Radio.Button
                active={activeIndex === 0 ? true : false}
                type="default"
                value={0}
                onClick={() => {
                  this.setActiveIndex(0, 0);
                }}
              >
                Immediately
              </Radio.Button>
              <Radio.Button
                active={activeIndex === 1 ? true : false}
                type="default"
                value={2}
                onClick={() => {
                  this.setActiveIndex(1, 2);
                }}
              >
                2 weeks
              </Radio.Button>
              <Radio.Button
                active={activeIndex === 2 ? true : false}
                type="default"
                value={4}
                onClick={() => {
                  this.setActiveIndex(2, 4);
                }}
              >
                4 weeks
              </Radio.Button>
              <Radio.Button
                active={activeIndex === 3 ? true : false}
                type="default"
                value={8}
                onClick={() => {
                  this.setActiveIndex(3, 8);
                }}
              >
                8 weeks
              </Radio.Button>
              <Radio.Button
                active={activeIndex === 5 ? true : false}
                type="default"
                value={52}
                onClick={() => {
                  this.setActiveIndex(5, 52);
                }}
              >
                1 year
              </Radio.Button>
            </Radio.Group>

            {hasPendingBill && (
              <Typography.Paragraph
                strong
                type="danger"
                style={{ marginTop: 14 }}
              >
                NOTE: There are pending billable RTM codes available, are you
                sure you want to discharge the patient?
              </Typography.Paragraph>
            )}
          </React.Fragment>
        ) : (
          <React.Fragment>
            <Typography.Paragraph>
              After readmission, this patient will be able to access their Home
              Exercise Program. They will also receive an email notifying them
              with instructions to access the app.
            </Typography.Paragraph>
          </React.Fragment>
        )}
      </Modal>
    );
  }
}

export default DischargeModal;
